import { render, staticRenderFns } from "./OurGirls.vue?vue&type=template&id=dfcd34fe"
import script from "./OurGirls.vue?vue&type=script&lang=js"
export * from "./OurGirls.vue?vue&type=script&lang=js"
import style0 from "./OurGirls.vue?vue&type=style&index=0&id=dfcd34fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../repos/mylovelyladyhere.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports